import { useGetList } from "ra-core";
import { getSupabaseClient } from "../../providers/supabase/supabase";

/**
 * Inscribe a un contacto en una cadencia. El trigger enrollment_create_tasks
 * crea una tarea por paso (sales_id = quien inscribe, para que salga en su Mi día).
 * Si no se da el deal, usa la oportunidad abierta de su empresa en esa oferta.
 */
export const enroll = async ({
  sequenceId,
  offerId,
  contactId,
  companyId,
  dealId,
  salesId,
}: {
  sequenceId: number;
  offerId: number | null;
  contactId: number;
  companyId?: number | null;
  dealId?: number | null;
  salesId: number;
}) => {
  const sb = getSupabaseClient();
  let deal = dealId ?? null;
  if (!deal && companyId && offerId) {
    const { data } = await sb
      .from("deals")
      .select("id")
      .eq("company_id", companyId)
      .eq("offer_id", offerId)
      .is("archived_at", null)
      .limit(1);
    deal = data?.[0]?.id ?? null;
  }
  const { error } = await sb.from("sequence_enrollments").insert({
    sequence_id: sequenceId,
    contact_id: contactId,
    deal_id: deal,
    sales_id: salesId,
  });
  if (error?.code === "23505") {
    throw new Error("Ya está inscrito en esa cadencia");
  }
  if (error) throw error;
};

export type Sequence = {
  id: number;
  offer_id: number | null;
  name: string;
  active: boolean;
};

export const useSequences = () =>
  useGetList<Sequence>("sequences", {
    pagination: { page: 1, perPage: 200 },
    sort: { field: "name", order: "ASC" },
    filter: { active: true },
  });
